import type { PresentationState, Scene } from "../types";
import { isPlayableMapScene } from "./media-map";

export function livePresentationTarget(presentation: PresentationState): string | undefined {
  return presentation.sessionWaiting ? undefined : presentation.overrideSceneId ?? presentation.activeSceneId;
}

export function presentationIsFrozen(presentation: PresentationState): boolean {
  return Boolean(presentation.stagedSceneId && presentation.stagedSceneId === livePresentationTarget(presentation));
}

export function sceneIsLive(sceneId: string | undefined, presentation: PresentationState): boolean {
  return Boolean(sceneId && !presentation.sessionWaiting && !presentation.blackout && !presentation.tokenPlacementMode && !presentation.stagedSceneId && sceneId === livePresentationTarget(presentation));
}

export function shouldOfferTokenPlacement(scene: Scene): boolean {
  return isPlayableMapScene(scene) && scene.tokens.some((token) => token.type === "player");
}
